module.exports = __webpack_public_path__ + "static/media/connectedAccountDark.d46f93a8.svg";